export const IS_LOCALHOST = window.location.hostname === 'localhost'

const runtimeEnv = window._env_ || {}

export const SERVER_URL =
    process.env.REACT_APP_SERVER_URL ||
    (IS_LOCALHOST ? 'http://localhost:8080' : window.location.protocol + '//' + window.location.hostname)

export const IS_DEV = SERVER_URL.toLowerCase().includes("dev") || IS_LOCALHOST
export const IS_PRELIVE = SERVER_URL.toLowerCase().includes("prelive")

export const PROFILE = IS_DEV ? "DEV" : "PROD"

const defaultWidgetBaseUrl = IS_LOCALHOST ? 'http://localhost:3030' :
    IS_PRELIVE ? "https://widget-prelive.motortech.ai" :
        IS_DEV ? "https://widget-dev.motortech.ai" : "https://widget.motortech.ai"

export const WIDGET_BASE_URL =
    runtimeEnv.WIDGET_URL ||
    process.env.REACT_APP_WIDGET_BASE_URL ||
    defaultWidgetBaseUrl

export const BACKEND_URL =
    runtimeEnv.PLATFORM_BASE_URL ||
    process.env.REACT_APP_BACKEND_URL ||
    SERVER_URL
